var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"organization-level-icon",style:(_vm.fontStyle)},[_c('v-icon',_vm._b({attrs:{"color":_vm.color,"size":_vm.size}},'v-icon',_vm.$attrs,false),[_vm._v(_vm._s(_vm.icons[_vm.organization.level]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }